module.exports = __webpack_public_path__ + "img/information_technology_thumbnail-400x300.2eeea457.jpg";